<template>
  <div id="app">
    <h1 style="display: none;" data-seo="用于seo">ColorOS 11</h1>
    <navigation :visible="isMobile" />
    <banner />
    <Nav />
    <Android11Oversea v-if="lang !== 'zh'" />
    <Personality />
    <high-efficiency />
    <fluent />
    <Photography v-if="lang === 'zh'" />
    <privacy v-if="lang === 'zh'" />
    <MoreOversea />
    <remarks />
    <navigation-footer v-if="lang === 'zh'" :visible="isMobile" />
    <navigation-footer-oversea v-if="lang !== 'zh'" />
    <full-screen-video />
  </div>
</template>

<script>
import { loadLanguageAsync } from './i18n';
import sitesMap from './sitesConfig/sitesMap';
import configKeys from './sitesConfig/configKeys';
import './directives/textMotionDirective';
import './directives/webpDirective';
import Navigation from '@/components/Navigation.vue';
import NavigationFooter from '@/components/Footer.vue';
import NavigationFooterOversea from '@/components/FooterOversea.vue';
import FullScreenVideo from '@/components/FullScreenVideo';
import Banner from './components/Banner/index';
import Nav from './components/Banner/navigators';
import Android11Oversea from './components/Banner/Android11Oversea';
import Fluent from './components/Fluent';
import HighEfficiency from './components/HighEfficiency';
import Personality from './components/Personality/index';
import Privacy from './components/Privacy';
import Photography from './components/Photography/index';
import MoreOversea from './components/UserPrivacy/moreOverea';
import Remarks from './components/UserPrivacy/remarks';
import { checkMobile, locationSearchParse } from '@/util';
import { WOW } from 'wowjs';
import Controller from './util/scrollMagic';

import './index.scss';
export default {
  name: 'App',
  components: {
    Banner,
    Navigation,
    NavigationFooter,
    NavigationFooterOversea,
    FullScreenVideo,
    Nav,
    Android11Oversea,
    Fluent,
    HighEfficiency,
    Personality,
    Privacy,
    Photography,
    Remarks,
    MoreOversea
  },
  provide() {
    return {
      // 不需要反复更改
      lang: this.lang,
      vm: this
    };
  },
  data() {
    const urlLang = (/\.com\/([a-zA-Z]{2,4}-?[a-zA-Z]{0,2})\/coloros/g.exec(location.href) || [])[1];
    const lang = urlLang ? urlLang : locationSearchParse()['languagetest'] || 'zh';
    return {
      lang,
      isMobile: '',
      config: {},
      isIE: !!window.ActiveXObject || 'ActiveXObject' in window
    };
  },
  created() {
    if (checkMobile() || window.innerWidth < 734) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted() {
    if (location.hash === '#limitless-screen') this.directTo(location.hash);
    this.loadConfig();
    loadLanguageAsync(this.lang).then(() => {
      this.$nextTick(() => {
        if (this.$t('description') && this.$t('description') !== 'description') {
          document.querySelector('meta[name="description"]').content = this.$t('description');
        }
        if (this.$t('keyWords') && this.$t('keyWords') !== 'keyWords') {
          document.querySelector('meta[name="keywords"]').content = this.$t('keyWords');
        }
      });
    });
    window.addEventListener('resize', this.handleResize);
    this.initWow();
  },
  methods: {
    // 外销站点配置
    loadConfig() {
      if (!this.lang) return;
      const setConfig = () => {
        for (let i = 0; i < configKeys.length; i++) {
          this.$set(this.config, configKeys[i], window[configKeys[i]]);
        }
      };
      // 外销用于首次预渲染，后续加载直接上 window
      if (location.href.indexOf('localhost:80') > -1 && Object.keys(sitesMap).indexOf(this.lang) > -1) {
        const site = sitesMap[this.lang];
        import(/* webpackChunkName: "site-config-[request]" */ `./sitesConfig/${site}`).then(() => {
          setConfig();
        });
      } else {
        setConfig();
      }
    },
    setFullScreenVideo(video) {
      this.fullScreenVideo = video;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 734;
    },
    initWow() {
      new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: screen.availHeight * 0.5,
        mobile: true,
        live: false
      }).init();
    },
    directTo(hash) {
      Controller.scrollTo(hash);
    }
  }
};
</script>
